/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Head from 'next/head';
import { Provider } from 'react-redux';
import withReduxStore from '../lib/with-redux-store';

function MyApp({ Component, pageProps, reduxStore }) {
  return (
    <>
      <Head>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>
      <Provider store={reduxStore}>
        <Component {...pageProps} />
      </Provider>
    </>
  );
}
// }

export default withReduxStore(MyApp);
